// ##############################
// // // Essity view styles
// #############################

import green from "@material-ui/core/colors/green";
import pricingPageStyle from 'assets/jss/material-dashboard-pro-react/views/pricingPageStyle.jsx'

const style = {
    btnOPBlack: {
        borderRadius: '0',
        color: '#fff',
        backgroundColor: '#00005a',
        fontFamily: 'Roboto',
        fontWeight: '700',
        padding: '12px 30px',
        fontSize: '14px',
        display: 'inline-block',
        overflow: 'hidden',
        margin: '0 30px 0 0',
        whiteSpace: 'normal',
        textTransform: 'none',

        '&:hover': {
            background: '#00005a',
            color: '#ffffff',
        },

        '&:focus': {
            background: '#00005a',
            color: '#ffffff',
        },
    },
    cornerRibbon:{
        left: '0px',
        width: '100%',
        zIndex: 20,
        opacity: 0.8,
        position: 'absolute',
        background: '#0099ff',
        height: '100%',
        borderRadius:'5px',
    },
    btnOPBlack2: {
        borderRadius: '0',
        color: '#fff',
        backgroundColor: '#00005a',
        fontFamily: 'Roboto',
        fontWeight: '700',
        padding: '12px 30px',
        fontSize: '14px',
        display: 'inline-block',
        overflow: 'hidden',
        margin: '0 30px 0 0',
        whiteSpace: 'normal',
        height: '65px',
        textTransform: 'none',
        lineHeight: '38px',

        '&:hover': {
            background: '#00005a',
            color: '#ffffff',
        },

        '&:focus': {
            background: '#00005a',
            color: '#ffffff',
        },
    },

    imgLogoBrand: {
        float: 'right'
    },

    btnOPTransp: {
        borderRadius: '0',
        border: 'none',
        color: '#fff',
        backgroundColor: '#f50082',
        fontFamily: 'Roboto',
        fontWeight: '700',
        padding: '.8em 2em',
        fontSize: '14px',
        display: 'inline-block',
        overflow: 'hidden',
        margin: '0',
        whiteSpace: 'normal',
        textTransform: 'none',

        '&:hover': {
            background: '#f50082',
            color: '#ffffff',
        },

        '&:focus': {
            background: '#f50082',
            color: '#ffffff',
        },
    },

    btnOPTranspBig: {
        borderRadius: '0',
        border: '1px solid #f50082',
        color: '#fff',
        backgroundColor: '#f50082',
        fontFamily: 'Roboto!important',
        fontWeight: '700',
        padding: '.8em 2em',
        fontSize: '14px',
        display: 'inline-block',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textTransform: 'initial',
        '&:hover': {
            background: '#f50082',
            color: '#ffffff',
        },
        '&:focus': {
            background: '#f50082',
            color: '#ffffff',
        },
    },

    btnOPBlackDetailOp: {
        borderRadius: '0',
        color: '#fff',
        backgroundColor: '#00005a',
        fontFamily: 'Roboto!important',
        fontWeight: '700',
        padding: '.8em 2em',
        fontSize: '14px',
        display: 'inline-block',
        overflow: 'hidden',
        margin: '0 20px 0 0',
        whiteSpace: 'normal',
        textTransform: 'initial',

        '&:hover': {
            background: '#00005a',
            color: '#ffffff',
        },

        '&:focus': {
            background: '#00005a',
            color: '#ffffff',
        },
    },

    btnAddProductDetailOP: {
        color: '#000',
        fontFamily: 'Roboto',
        fontWeight: '700',
        fontSize: '14px',
        backgroundColor: '#0000',
        border: 'none',
        boxShadow: 'none',
        padding: '0',

        '&:hover': {
            color: '#319ebb',
        },

        '&:focus': {
            color: '#319ebb',
        },
    },

    btnBarDetailOp: {
        textAlign: 'right',
    },

    opListWrapper: {
        paddingTop: '135px',
    },

    opWrapper: {
        marginTop: '0',
        marginBottom: '30px',
    },

    btnBarLoginModal: {
        textAlign: 'center',
        marginBottom: '50px',
    },

    btnLoginModal: {
        margin: '0 15px',
        color: '#00005a',
        border: '1px solid #00005a',
        borderRadius: '0',
        fontFamily: 'Roboto',
        fontWeight: '700',
        textTransform: 'initial',

        '&:hover': {
            background: '#00005a',
            color: '#ffffff',
        },

        '&:focus': {
            background: '#00005a',
            color: '#ffffff',
        },
    },

    modalTitle: {
        fontFamily: 'Roboto',
        fontWeight: '700',
        marginBottom: '0',
        textAlign: 'left',
        color: '#00005a',
        fontSize: '21px',
        textTransform: 'initial',

    },

    closeButtonModal: {
        position: 'absolute',
        right: '10px',
        top: '10px',
        color: '#00005a',
    },

    modalText: {
        fontFamily: 'Roboto',
        fontWeight: '400',
        color: '#000',
    },

    modalListWrapper: {
        fontFamily: 'Roboto',
        fontWeight: '400',
        color: '#000',
        paddingLeft: '20px',
        marginBottom: '0',
    },

    modalListItemBold: {
        fontFamily: 'Roboto',
        fontWeight: '700',
        color: '#00005a',
    },

    fullLogo: {
        marginBottom: '25px',
        marginTop: '50px',
    },

    modalPhoneText: {
        fontFamily: 'Roboto',
        fontWeight: '700',
        fontSize: '35px',
    },

    btnModalBlack: {
        borderRadius: '0',
        color: '#fff',
        backgroundColor: '#00005a',
        fontFamily: 'Roboto',
        fontWeight: '700',
        padding: '.8em 2em',
        minWidth: '12rem',
        minHeight: '3rem',
        display: 'inline-block',
        overflow: 'hidden',

        '&:hover': {
            background: '#666',
            color: '#ffffff',
        },

        '&:focus': {
            background: '#666',
            color: '#ffffff',
        },
    },

    btnModalTransp: {
        borderRadius: '0',
        color: '#00005a',
        backgroundColor: '#fff',
        fontFamily: 'Roboto',
        fontWeight: '700',
        padding: '.8em 2em',
        minWidth: '12rem',
        minHeight: '3rem',
        display: 'inline-block',
        overflow: 'hidden',

        '&:hover': {
            background: '#00005a',
            color: '#ffffff',
        },

        '&:focus': {
            background: '#00005a',
            color: '#ffffff',
        },
    },

    btnLogin: {
        borderRadius: '0',
        backgroundColor: '#00005a',
        fontFamily: 'Roboto',
        fontWeight: '700',
        padding: '.8em 2em',
        minWidth: '12rem',
        minHeight: '3rem',
        display: 'inline-block',
        overflow: 'hidden',
        textTransform: 'initial',

        '&:hover': {
            background: '#666',
            color: '#ffffff',
        },

        '&:focus': {
            background: '#666',
            color: '#ffffff',
        },
    },
    footer: {
        left: "0",
        right: "0",
        bottom: "0",
        padding: "15px 0",
        zIndex: 4,
    },

    btnPart: {
        borderRadius: '0',
        border: 'none',
        color: '#fff',
        backgroundColor: '#319ebb',
        fontFamily: 'Roboto',
        fontWeight: '700',
        padding: '.8em 2em',
        fontSize: '14px',
        display: 'inline-block',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textTransform: 'none',
        marginRight:'10px',


        '&:hover': {
            background: '#f50082',
            color: '#ffffff',
        },

        '&:focus': {
            background: '#f50082',
            color: '#ffffff',
        },
    },

    modalCloseButton: {
        '&:hover': {
            background: '#fff',
        },
        '& span': {
            justifyContent: 'flex-end',
            color: '#00005a',
        },
    },

    titleOP: {
        color: '#00005a',
        textTransform: 'none',
        marginTop: '0',
        fontSize: '22px',
        display: 'inline-block'
    },
    statusOperation: {
        display: 'inline-block',
        float: 'right',
        color: '#ffffff',
        backgroundColor: '#009a44',
        borderRadius: '3px',
        padding: '8px',
        lineHeight: '10px',
        fontSize: '11px',
        fontWeight: '500',
    },
    statusOperationFinish: {
        display: 'inline-block',
        float: 'right',
        color: '#ffffff',
        backgroundColor: '#ff0000',
        borderRadius: '3px',
        padding: '8px',
        lineHeight: '10px',
        fontSize: '11px',
        fontWeight: '500',
    },
    descrOP: {
        color: '#000!important',
        fontFamily: 'Roboto',
        fontWeight: '400',
        paddingTop: '0',
        fontSize: '14px',
        textAlign: 'left',
    },

    btnPswForget: {
        color: '#f50082',
        fontSize: '14px',
        margin: '0 auto 40px auto',
        maxWidth: 'initial',

        '&:hover': {
            background: '#fff',
            color: '#f50082',
        }
    },

    errorSaveOP: {
        fontFamily: 'Roboto',
        fontWeight: '400',
        fontSize: '14px',
        color: '#ff0000',
    },

    cardHeaderToto: {
        background: 'red!important',

        '& h4': {
            fontWeight: '700 !important',
        }
    },
    btnEye: {
        color: '#f3961d',
        cursor: 'pointer'
    },
    fab: {
        backgroundColor: '#0093d0',
    },
    btnCheck: {
        backgroundColor: 'red'
    },
    chip: {
        marginTop: '10px',
        marginBottom: '10px',
        backgroundColor: green[500],
    },
    greenAvatar: {
        margin: '10px -10px 10px 10px',
        color: '#fff',
        backgroundColor: green[500],
    },
    btnYellow: {
        borderRadius: '20px',
        backgroundColor: '#319ebb',
    },
    btnAddProduct: {
        backgroundColor: 'transparent',
        color: '#319ebb',
        boxShadow: 'none',
        textTransform: 'none',
        paddingLeft: '0',
        fontWeight: '700',
        fontSize: '14px',
        '&:hover': {
            backgroundColor: 'transparent',
            color: '#ea8905',
            textDecoration: 'underline',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: 'transparent',
            color: '#ea8905',
            boxShadow: 'none',
        },
    },
    titleEdit: {
        color: '#000 !important',
        fontSize: '25px',
        marginTop: '130px!important',
        fontWeight: '700!important',
        textTransform: 'uppercase',
    },
    registerButtonBis: {
        backgroundColor: '#319ebb!important',
        boxShadow: '0 2px 2px 0 rgb(206, 170, 37), 0 3px 1px -2px rgb(243, 198, 30), 0 1px 5px 0 rgba(76, 175, 80, 0.12)',
        '&:hover': {
            boxShadow: 'box-shadow: 0 14px 26px -12px rgb(171, 140, 25), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(76, 175, 80, 0.2)',

        }
    },
    cardTitle: {
        textAlign: "center",
        color: '#fff',
        fontWeight: '900',
    },

    center: {
        textAlign: "center"
    },
    title: {
        color: '#00005a!important',
    },
    titleProfil: {
        color: '#0099ff!important'
    },
    fullPageBg: {
        backgroundColor: "#f8f8f8!important",
    },
    titleWhite: {
        color: '#00005a',
        fontFamily: 'Roboto',
        fontWeight: '700',
        fontSize: '25px',
        textTransform: 'uppercase',
        marginTop: '130px',
        marginBottom: '0px',
        textAlign: 'center',
    },

    limitTitle: {
        color: '#000',
        fontSize: '15px',
        margin: '15px 0 15px 0',
        fontFamily: 'Roboto',
        fontWeight: '400',
        textAlign: 'center',
    },

    opLimitParticipation: {
        background: '#0099ff',
        color: '#fff',
        borderRadius: '6px',
        padding: '20px',
        margin: '50px 0 30px 0',
    },

    opLimitPartText: {
        margin: '0',
        fontSize: '16px',
        fontFamily: 'Roboto',
        fontWeight: '400',
    },

    opLimitPartSpan: {
        fontFamily: 'Roboto',
        fontWeight: '900',
        textTransform: 'uppercase',
    },

    opTitle: {
        color: '#00005a',
        fontSize: '22px',
        textTransform: 'none',
        textAlign: 'center',
        margin: '0',
    },

    opImg: {
        width: '45%',
    },

    btnBarOP: {
        textAlign: 'left',
    },

    ListOPDetail: {
        paddingLeft: '10px',
    },

    ListLiOPDetail: {
        marginBottom: '5px',
    },

    textListOPDetail: {
        fontFamily: 'Roboto!important',
        fontWeight: '400',
        fontSize: '16px',
        margin: '0px 10px 0px 0px',
        color: '#000',
    },

    linkFooter: {
        color: '#f50082!important',
        textTransform: 'none',
        "&,&:hover,&:focus": {
            TextDecoration: 'underline',
        },
    },

    loginHeader: {
        background: '#f50082',
        borderRadius: '0',
        marginTop: '-45px',
        marginLeft: '15px',
        marginRight: '15px',
    },

    btnUpload: {
        borderRadius: '40px',
        backgroundColor: '#319ebb',
        padding: '15px 2em',
        minWidth: '12rem',
        minHeight: '3rem',
        fontWeight: '700',
        display: 'inline-block',
        overflow: 'hidden',

        '&:hover': {
            background: '#ea8905',
            color: '#ffffff',

            '&::after': {
                transform: 'translate(0,0)',
                transition: 'transform .75s',
                backfaceVisibility: 'hidden',
            }
        },

        '&:focus': {
            background: '#ea8905',
            color: '#ffffff',

            '&::after': {
                transform: 'translate(0,0)',
                transition: 'transform .75s',
                backfaceVisibility: 'hidden',
            }
        },
    },
    criteresUpload: {
        color: '#636466',
        marginRight: '10px',
    },
    alignRight: {
        textAlign: 'right',
    },

    customImageOperation: {
        width: '100%',
        marginTop: '-40px',
        boxShadow: '0px 0px 20px 0px rgba(0,0,0,0.2)',
        borderRadius: '3px',
    },

    customTableImage: {
        width: '100%',
    },
    labelOperationGeneric:{
        color:'#f50082'
    },
    ...pricingPageStyle
}

export default style;





// WEBPACK FOOTER //
// ./src/assets/css/style.jsx